import request from '@/utils/request'

/**
 * 获取厂家列表
 */

export const getManufacturerLists = () => {
    return request({
        url: '/manufacturer/option/lists'
    })
}
/**
 * 导出厂家类型列表
 */
export const getExportManufacturerLists = (data) => {
    return request({
        url: '/manufacturer/lists',
        params: data
    })
}

// 厂家类型-删除
export const delManufacturerType = (id) => {
    return request({
        url: `/manufacturer/${id}`,
        method: 'DELETE'
    })
}

// 厂家类型-添加
export const addManufacturerType = (data) => {
    return request({
        url: '/manufacturer/manage',
        method: 'POST',
        data
    })
}

// 厂家类型-详情
export const getManufacturerDetail = (id) => {
    return request({
        url: `/manufacturer/${id}`
    })
}

// 厂家类型-编辑
export const putManufacturerType = (data) => {
    return request({
        url: '/manufacturer/manage',
        method: 'PUT',
        data
    })
}

/**
 * 下载导入模板
 */
export const getManufacturerTemplateUrl = () => {
    return request({
        url: '/manufacturer/excel/imports'
    })
}
// 厂家-导入
export const importsManufacturer = (data) => {
    return request({
        url: '/manufacturer/excel/imports',
        method: 'POST',
        data
    })
}
